/**
 * Certificates Selectors
 */

import type { CertificatesState } from './certificates.slice'

type State = { certificates: CertificatesState }

export const selectCertificatesState = (state: State) => state.certificates
export const selectAllCertificates = (state: State) => state.certificates.items
export const selectCertificatesLoading = (state: State) => state.certificates.loading
export const selectCertificatesSaving = (state: State) => state.certificates.saving
export const selectCertificatesError = (state: State) => state.certificates.error
export const selectCertificatesDrawerOpen = (state: State) => state.certificates.drawerOpen
export const selectCertificatesDrawerMode = (state: State) => state.certificates.drawerMode
export const selectSelectedCertificate = (state: State) => state.certificates.selected
export const selectCertificatesFilter = (state: State) => state.certificates.filter

export const selectFilteredCertificates = (state: State) => {
  const { items, filter } = state.certificates

  return items.filter((cert) => {
    if (filter.type === 'general' && !cert.isGeneral) return false
    if (filter.type === 'variant' && cert.isGeneral) return false
    if (filter.isActive === 'true' && !cert.isActive) return false
    if (filter.isActive === 'false' && cert.isActive) return false
    if (filter.search) {
      const q = filter.search.toLowerCase()
      if (!cert.title.toLowerCase().includes(q) && !(cert.description ?? '').toLowerCase().includes(q)) {
        return false
      }
    }
    return true
  })
}
